import { Component, OnInit, Inject, ChangeDetectorRef, OnDestroy, AfterViewInit, AfterViewChecked, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CarrierApiService } from '../../services/carrier-api.service';
import { fromEvent } from 'rxjs';
import { map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import * as _ from 'lodash';
import { Storage } from '../../../core/services/storage.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics/google-analytics.service';
import { ImpersonateCarrierService } from 'src/app/shared/services/impersonate-carrier.service';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { get } from 'lodash';

@Component({
  selector: 'hg-change-carrier',
  templateUrl: './change-carrier.component.html',
  styleUrls: ['./change-carrier.component.scss'],
})

export class ChangeCarrierComponent implements OnInit, AfterViewInit, OnDestroy, AfterViewChecked {
  public carrierOptions = [];
  public carrierDetails: any;
  public selectValue = '';
  public selectedCarrier;
  public carrierNamesList = [];
  public searchVal: string = '';
  public splitValue: any;
  public currentUser: any;
  public entitlements: any;
  public allCarrierValues: any;
  public carrierInformation: string = '';
  public disableTypeAheadOption: boolean = false;
  public disableEmailOption: boolean = true;
  public invalidCarrier: boolean = false;
  public invalidEmailAddress: boolean = false;
  public carrierExistsForEmail: boolean = false;
  public carrierDoesNotExistForEmail: boolean = false;
  public minLetterErr: boolean = false;
  public disableCarrierButton: boolean = false;

  constructor(
    private googleAnalyticsSvc: GoogleAnalyticsService,
    private storageService: Storage,
    private cdRef: ChangeDetectorRef,
    private carrierService: CarrierApiService,
    private currentUserService: CurrentUserService,
    private impersonateCarrierService: ImpersonateCarrierService,
    private dialogRef: MatDialogRef<ChangeCarrierComponent>) {
    }

  async ngOnInit() {
    this.currentUser = await this.currentUserService.getUser();
    this.entitlements = (get(this.currentUser, 'userEntitlements') || []).map(entitlement => entitlement.code);
  }

  public closeMe() {
    this.dialogRef.close();
  }

  ngAfterViewInit() {
    this.getCarriersList();
  }

  ngAfterViewChecked() {
    document.getElementById('carrierSearch').focus();
    if(this.cdRef['detectChanges']) {
      this.cdRef.detectChanges();
    }
  }

  ngOnDestroy() {
    this.cdRef.detach();
  }

  public getCarriersList() {
    fromEvent(document.getElementById('carrierSearch'), 'input').pipe(
      map((e: KeyboardEvent) => {
        const element = e.target as HTMLInputElement;
        const value = element.value;
        return value;
      }),
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe((searchText: any) => {
      if (searchText.trim().length < 3) {
        this.minLetterErr = true;
      }
      if (!searchText || !searchText.trim().length || searchText.trim().length < 3) {
        this.carrierNamesList = [];
        this.invalidCarrier = false;
        this.disableCarrierButton = false;
        this.cdRef.detectChanges();
      } else {
        this.minLetterErr = false;
        this.carrierNamesList = [];
        this.carrierService.getCarriersList(searchText).then((data: any) => {
          if (data.length < 1) {
            this.blurCarrierInput()
          } else {
            this.carrierOptions = data;
            data.forEach((carrier, index) => {
              let sysconNumber = ' (Syscon# N/A) ';
              let name = carrier.carrierName;
              if (carrier.xrefIds.length < 1) {
              } else {
                carrier.xrefIds.forEach(xref => {
                  if (xref.systemName === 'TPS') {
                    sysconNumber = ' (Syscon#' + xref.id + ') ';
                  }
                })
              }
              name += sysconNumber;
              name += carrier.mcNumber ? ' (MC#' + carrier.mcNumber + ') ' : ' (MC# N/A) ';
              carrier.locations.forEach(location => {
                if (location.primary) {
                  if (location.address) {
                    name += ', ' + (location.address.city || 'N/A') + ', ' + (location.address.state || 'N/A') + ', ' + (location.address.zipCode || 'N/A');
                  }
                }
              });
              this.carrierNamesList.push(name);
              this.carrierOptions[index].displayCarrierName = name;
            });
            this.blurCarrierInput();
          }
        });
        if (!this.cdRef['destroyed']) {
          this.cdRef.detectChanges();
        }
      }
    });
  }
  selectCarrier(carrier: string) {
    this.disableCarrierButton = true;
    // this.splitValue = carrier.split(' (Syscon#');
    this.selectedCarrier = _.find(
      this.carrierOptions,
      data => data.displayCarrierName === carrier);
    this.searchVal = carrier;
    (<HTMLInputElement>document.getElementById('carrierSearch')).value = carrier;
    this.carrierNamesList = [];
  }

  blurCarrierInput() {
    if (!this.carrierNamesList.length && !this.allCarrierValues.length) {
      this.invalidCarrier = true;
    } else {
      this.invalidCarrier = false;
    }
  }

  // carrierSelectedFromDropDown(carrier) {
  //   this.selectValue = carrier;
  //   this.disableCarrierButton = true;
  //   let carrierName = carrier.split(' (Syscon#');
  //   this.selectedCarrier = _.find(
  //     this.carrierOptions,
  //     data => data.carrierName === carrierName[0].trim());
  // }

  selectOptions(event) {
    this.disableCarrierButton = false;
    if (event.value === 'typeahead') {
      window.setTimeout(()=> {
        (<HTMLInputElement>document.getElementById('carrierSearch')).focus();
      }, 0);
      // Option 1: typeahead selected then don't show error messages for emailaddress option.
      this.carrierExistsForEmail = false;
      this.carrierDoesNotExistForEmail = false;
      this.invalidEmailAddress = false;
      // Option 1: typeahead option selected then disable other and emailaddress option.
      this.disableTypeAheadOption = false;
      this.disableEmailOption = true;
      (<HTMLInputElement>document.getElementById('emailSearch')).value = ''
      //  empty all carriers associated with FC.
      this.allCarrierValues = [];
      return;
    }
    if (event.value === 'emailaddress') {
      window.setTimeout(() => {
        (<HTMLInputElement>document.getElementById('emailSearch')).focus();
      }, 0);
      // Option 2: emailaddress option selected then disable typeahead option.
      this.disableTypeAheadOption = true;
      this.disableEmailOption = false;
      (<HTMLInputElement>document.getElementById('carrierSearch')).value = '';
      this.minLetterErr = false;
      this.invalidCarrier = false;
      this.carrierNamesList = [];
      return;
    }
  }

  checkForEmailAddress(emailAddress) {
    if (emailAddress.length < 1) {
      this.invalidEmailAddress = false;
      this.carrierExistsForEmail = false;
      this.carrierDoesNotExistForEmail = false;
      return;
    }
    let emailRegex = /^\w+([\.-]?\w+)*(\+[a-zA-Z0-9-]+)?@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    let validEmail = emailRegex.test(emailAddress.trim());

    if (!validEmail) {
      this.invalidEmailAddress = true;
      this.carrierExistsForEmail = false;
      this.carrierDoesNotExistForEmail = false;
      this.disableCarrierButton = false;
      return;
    }
    this.invalidEmailAddress = false;
    this.disableCarrierButton = true;

    if (!this.invalidEmailAddress) {
      this.carrierService.getUserFromEmailAddress(emailAddress.trim())
        .then(async userObj => {
          if (userObj && userObj.organizationCode && userObj.organizationName) {
            this.carrierDetails = await this.carrierService.getCarrierProfile(userObj.organizationCode);
            this.carrierInformation = this.buildCarrierInfo(this.carrierDetails);
            this.carrierExistsForEmail = true;
            this.carrierDoesNotExistForEmail = false;

            this.selectedCarrier = {};
            this.selectedCarrier.carrierName = userObj.organizationName;
            this.selectedCarrier.carrierId = userObj.organizationCode;
          } else {
            this.carrierExistsForEmail = false;
            this.carrierDoesNotExistForEmail = true;
            this.disableCarrierButton = false;
          }
        }).catch(e => {
          console.log(e);
        });
    }
  }

  checkForValidData() {
    return this.disableCarrierButton = this.carrierInformation.length && !this.invalidEmailAddress && this.carrierExistsForEmail ? true :  false;
  }

  buildCarrierInfo(carrierInfo) {
    return carrierInfo.carrierName + ' (Syscon#' + (carrierInfo.vendorNumber || 'N/A') + ') ' + ' (MC#' + (carrierInfo.mcNumber || 'N/A') + ') ' +
      (carrierInfo.headquarters.city || 'N/A') + ', ' + (carrierInfo.headquarters.state || 'N/A') + ',' + (carrierInfo.headquarters.zipCode || 'N/A')
  }

  clearInputValue() {
    this.disableCarrierButton = false;
    (<HTMLInputElement>document.getElementById('carrierSearch')).value = '';
  }

  changeCarrier() {
    const impersonateNo = "Carrier Support option " + (!this.disableEmailOption ? 2 : 1);
    this.storageService.setItem('organizationCode', this.selectedCarrier.carrierId);
    this.storageService.setItem('organizationName', this.selectedCarrier.carrierName);
    this.googleAnalyticsSvc.register(`Internal Admin Impersonate - ${impersonateNo}`, `MC#${this.selectedCarrier.mcNumber || (this.carrierDetails && this.carrierDetails.mcNumber) || 'N/A'} - ${this.selectedCarrier.carrierName}`);
    this.dialogRef.close();
    this.impersonateCarrierService.carrierChanged();
  }
}
